export default "__VITE_ASSET__CLr1BtkH__"